import type { MouseEventHandler } from "react";
import { useEffect } from "react";

export const useOnClickOutside = (
  ref: React.MutableRefObject<any> | React.MutableRefObject<any>[],
  handler: MouseEventHandler,
): void => {
  useEffect(() => {
    const listener = (event) => {
      if (Array.isArray(ref)) {
        const els = ref.filter(Boolean).map((i) => i.current as HTMLElement);
        if (!els.some(Boolean) || els.some((el) => el?.contains(event.target)))
          return;
      } else {
        const el = ref.current as HTMLElement;
        if (!el || el.contains(event.target)) {
          return;
        }
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
